import { render, staticRenderFns } from "./TagChip.vue?vue&type=template&id=5bbe1734&scoped=true"
import script from "./TagChip.vue?vue&type=script&lang=ts"
export * from "./TagChip.vue?vue&type=script&lang=ts"
import style0 from "./TagChip.vue?vue&type=style&index=0&id=5bbe1734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe1734",
  null
  
)

export default component.exports